module.exports = __webpack_public_path__ + "img/Weapon_231.d83db61e.png";